import { useBack, useBackMultipart } from "../http";
import { DeliveryDocumentContactsDTO } from "../types/DeliveryDocumentContactsDTO";
import { DeliveryDocumentDTO } from "../types/DeliveryDocumentDTO";
import { DeliveryDocumentsByGroupDTO } from "../types/DeliveryDocumentsByGroupDTO";
import { DocumentsGroupDTO } from "../types/DocumentsGroupDTO";
import { TemplateDTO } from "../types/TemplateDTO";

export class DocumentsService {
	constructor() {}
	axiosInstance = useBack();
	axiosInstanceMultipart = useBackMultipart();

	async getGroups() {
		try {
			const response = await this.axiosInstance.get<DocumentsGroupDTO[]>('/documents/groups');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os grupos de empresas`, error);
			return undefined;
		}
	}

	async getDeliveriesByGroup(id: string) {
		try {
			const response = await this.axiosInstance.get<DeliveryDocumentsByGroupDTO>(`/documents/groups/${id}/deliveries`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os envios de documento`, error);
			return undefined;
		}
	}

	async create(cnpj: string) {
		const data = { cnpj: cnpj }
		return await this.axiosInstance.post(`/documents/groups`, data);
	}

	async createCompany(id: string, cnpj: string) {
		const data = { cnpj: cnpj }
		return await this.axiosInstance.post(`/documents/groups/${id}/company`, data);
	}

	async getContactsFromCompany(id: number | undefined) {
		if (!id) return null;
		try {
			const response = await this.axiosInstance.get<DeliveryDocumentContactsDTO>(`/documents/groups/${id}/contacts`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os envios de documento`, error);
			return undefined;
		}
	}

	async sendNewDelivery(id: string | undefined, form: FormData) {
		const response = await this.axiosInstanceMultipart
			.post(`/documents/groups/${id}/deliveries`, form);
		return {...response};
	}

	async updateDelivery(id: number, form: FormData) {
		const response = await this.axiosInstanceMultipart
			.put(`/documents/deliveries/${id}`, form);
		return {...response};
	}

	async deleteDelivery(id: number) {
		const response = await this.axiosInstance
			.delete(`/documents/deliveries/${id}`);
		return {...response};
	}

	async resendDelivery(id: string | undefined, data: DeliveryDocumentDTO) {
		const response = await this.axiosInstance
			.post(`/documents/groups/${id}/deliveries/resend`, data);
		return {...response};
	}

	async getTemplates() {
		const response = await this.axiosInstance.get<TemplateDTO[]>(`/documents/template`);
		return {...response};
	}

	async createTemplate(template: TemplateDTO) {
		const response = await this.axiosInstance.post(`/documents/template`, template);
		return {...response};
	}

	async confirmSendDocuments(ids: number[]) {
		const response = await this.axiosInstance.post(`/documents/confirm`, ids);
		return {...response};
	}
}